module.exports = __webpack_public_path__ + "img/cognitive_img02.2697630d.png";